<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
    <p>Component for upload file by selecting or dragging</p>
    <docs-section [content]="componentContent"></docs-section>
</demo-section>
  